import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
// modules
import user from "./modules/user";
import exam from "./modules/exam";
import notify from "./modules/notify";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    exam,
    notify,
  },
  getters,
});

export default store;
